module.exports = __webpack_public_path__ + "img/logout_icon.1198da19.svg";